import { forwardRef, Ref } from 'react';
import ReactHighcharts from 'highcharts-react-official';
import { useRecoilValue } from 'recoil';
import { cloneDeep, merge } from 'lodash';
import moment from 'moment';

import { timezoneState } from 'components/common/Managers/PreferencesManager.state';

export type ScalyrHighchartsProps = ReactHighcharts.Props & {
  ignoreTimezone?: boolean
};

// Moment needs to be exposed globally for Highchart to make use of it
window.moment = moment;

/**
 * Wrapper over ReactHighcharts to automatically handle timezone offset
 */
const ScalyrHighcharts = forwardRef(
  function ScalyrHighcharts(props: ReactHighcharts.Props, ref: Ref<any>): JSX.Element {
    const { options, ignoreTimezone, ...rest } = props;
    const timezone = useRecoilValue(timezoneState);
    let chartOptions = options;

    if (!ignoreTimezone && timezone) {
      chartOptions = merge(
        cloneDeep(options),
        {
          time: {
            timezone,
            useUTC: true,
          },
        },
      );
    } else {
      chartOptions = merge(
        cloneDeep(options),
        {
          time: {
            useUTC: false,
          },
        },
      );
    }

    return <ReactHighcharts options={chartOptions} {...rest} ref={ref} />;
  },
);

export default ScalyrHighcharts;
